import { ITheme, memoizeFunction, mergeStyleSets } from '@ms/yammer-web-core-ui/dist/util/styling';

export const getClassNames = memoizeFunction((theme: ITheme) =>
  mergeStyleSets({
    logoImage: {
      fill: theme.palette.accent,
    },
    logoText: {
      paddingRight: 8,
    },
  })
);
